<template>
  <div class="publicItems">
    <div class="selectionArea">
      <!-- <div class="item">
        <span class="item_title">别名</span>
        <el-input v-model="parameter.alias" />
      </div> -->
      <div class="item">
        <span class="item_title">素材师</span>
        <el-input v-model="parameter.bind_name" />
      </div>
      <div class="item">
        <span class="item_titles">最近10天最高成本区间</span>
        <el-select
          v-model="parameter.max_cost_material"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item,index) in groupList"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>

    </div>

    <div>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        style="width: 100%"
        border
        @sort-change="sortChange"
      >
        <el-table-column
          prop="bind_name"
          label="素材师"
        />
        <el-table-column
          prop="cost_twenty_thousand_cnt"
          label="2W的次数"
        />
        <el-table-column
          prop="cost_thirty_thousand_cnt"
          label="3W的次数"
        />
        <el-table-column
          prop="cost_fifty_thousand_cnt"
          label="5W的次数"
        />
        <el-table-column
          prop="cost_one_hundred_thousand_cnt"
          label="10W的次数"
        />
        <el-table-column
          prop="cost_two_hundred_thousand_cnt"
          label="20W的次数"
        />
        <el-table-column
          prop="cost_five_hundred_thousand_cnt"
          label="50W的次数"
        />
        <el-table-column
          prop="cost_one_million_cnt"
          label="100W的次数"
        />
        <el-table-column
          prop="max_cost_material_last_10_day"
          label="截至统计日期，素材创建时间10天内最高的消耗"
          sortable
        />
        <el-table-column
          prop="max_cost_material_last_10_date"
          label="截至统计日期，素材创建时间10天内最高消耗的日期"
        />
      </el-table>
      <pagination-right
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
// import { video_material_cost } from '@/api/materialReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import ExpandClose from '@/components/ExpandClose/index.vue'
import { getmaterialData } from '@/api/adDetail.js'
export default {
  components: {
    PaginationRight
    // ExpandClose
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        bind_name: null,
        max_cost_material: null,
        material_engineer_name: null,
        max_cost_last_ten: null,
        name: null,
        material_id: null,
        account_id: null,
        summary_type: '1'
      },
      group_name: null,
      date: [this.getNowFormatDate(window.Date.now()), this.getNowFormatDate(window.Date.now())],
      activeItem: null,
      activeText: null,
      order_by: {}, // 表格数据排序
      groupList: [
        {
          label: '2万',
          value: '20000'
        },
        {
          label: '3万',
          value: '30000'
        },
        {
          label: '5万',
          value: '50000'
        },
        {
          label: '10万',
          value: '100000'
        },
        {
          label: '20万',
          value: '200000'
        },
        {
          label: '50万',
          value: '500000'
        },
        {
          label: '100万',
          value: '1000000'
        }
      ]
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    searchclick() {
      this.parameter.page = 1
      this.getDataList()
    },
    async getDataList() {
      const data = await getmaterialData({
        page: this.parameter.page,
        page_size: this.parameter.pageSize,
        bind_name: this.parameter.bind_name,
        max_cost_material: this.parameter.max_cost_material,
        // max_cost_last_ten: this.parameter.max_cost_last_ten,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      console.log('数据=====', data)
      this.tableData = data.data
      this.loading = false
    },

    // 选中哪一项
    handleSelect(item) {
      this.group_name = item.value
      this.parameter.group_id = item.address
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    // 列表排序
    sortChange(cell) {
      console.log('cell:', cell)
      this.order_by['order'] = !cell.order ? cell.order : cell.order === 'ascending' ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order ? cell.order : 'max_cost_material_last_10_day'
      this.getDataList()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        name: null,
        material_id: null,
        account_id: null,
        summary_type: '1'
      }
      this.group_name = null
      this.date = []
      this.order_by = {}
      this.$refs.tableRef.clearSort()
      this.getDataList()
    },

    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }

  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 55px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  // align-items: flex-end;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
      width: 60px;
       display: inline-block;
    }
    .item_titles{
      width: 156px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
.content1{
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.content1>div:nth-child(1){
  margin-right: 7rem;
}
.content1>div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}
.content1>div>div:nth-child(2){
  color: rgb(138, 37, 37);
}
</style>

